export const dictionaryKeys = {
  showingText: 'showingText',
  resultsText: 'resultsText',
  loadMoreText: 'loadMoreText',
  noResultFoundKey: 'noResultFoundKey',
  multiResultFoundKey: 'multiResultFoundKey',
  singleResultFoundKey: 'singleResultFoundKey',
};
